<template>
  <div>
    <div class="foot">
      <div class="w1300">
        <div class="nav">
          <ul>
            <li>导航链接</li>
            <li v-for="(item, index) in headerList" :key="index" @click="redirectToExternalUrl(item.url)">
              {{ item.title }}
            </li>
          </ul>
        </div>
      </div>
      <div class="banquan">{{banquan}}</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      headerList: [],
      banquan:"版权所有@某某某科技有限公司 冀@ICP备17005638号-20安全与隐私免责声明"
    };
  },
  methods:{
    async setting(){
      let res = await this.$get('/web/index/setting');
      if(res.code == 200){
        this.headerList = res.data.links_down_num

      }
    },
    redirectToExternalUrl(url) {
      window.open(url); // 将当前页面重定向到指定的外部URL
    },
  },
  mounted(){
    this.setting();
  }
};
</script>
<style scoped>
.foot img {
  width: 100%;
}
.nav {
  border-top: solid 1px #ce4a49;
  margin-top: 30px;
}
.nav ul {
  margin-top: 20px;
  overflow: hidden;
}
.nav ul li:first-child {
  font-size: 18px;
  font-weight: bold;
}
.nav ul li{float: left;margin-right: 25px;}
.banquan{background-color: #f6f6f6;color: #525252;margin-top: 30px;height: 50px;font-size: 14px;text-align: center;line-height: 50px;}
.nav ul li:hover{cursor: pointer;}
</style>